import React from 'react'
import { TXTLEFT_ICON, TXTCENTER_ICON, TXTRIGHT_ICON } from '../../../../../config/svgicons'
import { iconwrapper } from '../../../../../config/commonfunctions'

export const combineNames = (t, titletext, name, spousename, babyname) => {
    try {

        if (t === 'Wedding') {
            if (name.length === 0 && spousename.length === 0) {
                return ''
            }
            else if (name.length === 0 && spousename.length !== 0) {
                return spousename
            }
            else if (name.length !== 0 && spousename.length === 0) {
                return name
            }
            else {
                return [
                    <div id="ilookup_combinenames1" style={{ whiteSpace: 'nowrap', width: '100vw' }} key={name + 'name'}>{name}</div>,
                    <div id="ilookup_combinenames2" style={{ whiteSpace: 'nowrap', width: '100vw' }} key={spousename + 'spousename'}>{'& ' + spousename}</div>
                ]
            }
        }
        else if (t === 'House-Warming') {
            return titletext
        }
        else if (t === 'Baby Shower') {
            return titletext
        }
        else if (t === 'Birthday Party') {
            return titletext
        }
        else if (t === 'Postponement') {
            return titletext
        }
    }
    catch (e) { return '' }

}

export const AlignmentSelector = ({ sectionKey, css_map, updateBackup, setShowsave, updateDetailcss, showsave, selectA, selectB, selectC }) => {
    const alignments = [
        { type: selectA, icon: TXTLEFT_ICON, className: 'ie_sm' },
        { type: selectB, icon: TXTCENTER_ICON, className: 'ie_md' },
        { type: selectC, icon: TXTRIGHT_ICON, className: 'ie_lg' }
    ];

    const getStyle = (alignment) => {
        const isSelected = css_map[sectionKey]?.textAlign === alignment;
        return {
            backgroundColor: isSelected ? 'var(--maindark)' : 'transparent',
            color: isSelected ? 'white' : '#707070',
            border: 'none',
            height: 30,
            width: 30,
            borderRadius: isSelected ? 5 : 0
        };
    };

    const handleClick = (alignment) => {
        if (!showsave) {
            updateBackup();
            setShowsave(true);
        }
        updateDetailcss(sectionKey, alignment);
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'row',
            border: '1px solid var(--subgrey)',
            borderRadius: 5,
            overflow: 'hidden',
            padding: 5,
            marginBottom: 5,
            width: 'max-content',
            placeSelf: 'end'
        }}>
            {alignments.map(({ type, icon, className }) => (
                <div
                    key={type}
                    className={className}
                    style={getStyle(type)}
                    onClick={() => handleClick(type)}
                >
                    {iconwrapper(icon, {
                        width: 20,
                        height: 20,
                        display: 'flex',
                        placeContent: 'center'
                    })}
                </div>
            ))}
        </div>
    );
};